import { links } from '../links'
import type { PanelContent } from './de'

/**
 * Englische Fassung der Startseite.
 *
 * TODO (Kunde): Übersetzung aus dem Deutschen – bitte prüfen.
 */

export const panels: PanelContent[] = [
  {
    brand: 'cap',
    name: 'CAP',
    headline: ['The standard', 'for cooperation.'],
    primary: { label: 'More information', href: links.cap },
    secondary: { label: 'Get in touch', href: links.contactCap },
  },
  {
    brand: 'carrierhub',
    name: 'Carrier Hub',
    headline: ['Less dark.', 'More fiber.'],
    primary: { label: 'More information', href: links.carrierhub },
    secondary: { label: 'Get in touch', href: links.contactCarrierhub },
  },
]

export const footerLinks = [
  { label: 'Imprint', href: links.imprint },
  { label: 'Privacy', href: links.privacy },
  { label: 'vitroconnect.com', href: links.corporate },
]

export const ui = {
  skipToContent: 'Skip to content',
  toCarrierHub: 'To Carrier Hub',
  legal: 'Legal',
}
